import axios from 'axios'
import { csrfToken } from '@insided/deprecated-preact-components/utils/csrfToken'

export async function sendPrivateMessage(usernames: string[], message: string) {
  const formData = new window.FormData()
  usernames.forEach((username) => {
    formData.append('usernames[]', username)
  })
  formData.append('message', message)
  formData.append('yip_csrf_token', csrfToken())
  const headers = {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  }
  return await axios.post('/privateMessages/sendBatch', formData, headers)
}
